import { api } from '@services';

import Task, { ITaskApiRawQuery, ITaskRawQuery } from '@models/Task.model';

interface IRequest {
  taskId: string;
}

const getTask = async ({ taskId }: IRequest): Promise<ITaskRawQuery> => {
  const { data: task } = await api.get<ITaskApiRawQuery>(
    `/tasks/${taskId}/raw`,
  );

  return Task.fromApiRawQueryModel(task);
};

export { getTask };
